import PropTypes from 'prop-types'
import BasicObject from 'model/basicObject'
import InteractionModality from 'model/tickets/interactions/interactionModality'
import User from 'model/person/user'
import Chat from 'model/chats/chat'
import Claim from 'model/claims/claim'
import CarePlan from 'model/carePlans/carePlan'
import Appointment from 'model/appointments/appointment'
import { isNil, pathOr } from 'ramda'

const CHAT = 'Chat'
const CLAIM = 'ClaimV2'
const CARE_PLAN = 'RoadmapV2'
const APPOINTMENT = 'Appointment'

const enumResolver = entity => {
  // console.log('enumResolver', entity)
  if (isNil(entity)) return null
  const typename = entity.__typename
  switch (typename) {
    case CHAT:
      return new Chat(entity)
    case CLAIM:
      return new Claim(entity)
    case CARE_PLAN:
      return new CarePlan(entity)
    case APPOINTMENT:
      return new Appointment(entity)
    default:
      return null
  }
}

class Interaction extends BasicObject {
  constructor(init) {
    super(init)
    // console.log('> Interaction constructor -', init)
    if (isNil(init)) return undefined
    this._archived = init.archived
    this._created_at = init.created_at
    this._direction = init.direction
    this._interaction_modality = new InteractionModality(
      init.interaction_modality
    )
    this._interacted_with = init.interacted_with
    this._minutes_spent = init.minutes_spent
    this._contact_name = init.contact_name
    this._contact_detail = init.contact_detail
    this._notes = init.notes
    this._navigator = new User(init.navigator)
    this._owned_by_consumer = init.owned_by_consumer
    this._source = enumResolver(init.source)
  }

  static shape = {
    id: PropTypes.string.isRequired,
    archived: PropTypes.bool,
    created_at: PropTypes.string,
    direction: PropTypes.string,
    interaction_modality: PropTypes.instanceOf(InteractionModality),
    interacted_with: PropTypes.string,
    minutes_spent: PropTypes.number,
    notes: PropTypes.string,
    navigator: PropTypes.instanceOf(User),
    owned_by_consumer: PropTypes.bool,
    contact_name: PropTypes.string,
    contact_detail: PropTypes.string
  }

  get archived() {
    return this._archived
  }

  get created_at() {
    return this._created_at
  }

  get direction() {
    return this._direction
  }

  get interaction_modality() {
    return this._interaction_modality
  }

  get interacted_with() {
    return this._interacted_with || ''
  }

  get contact_name() {
    return this._contact_name || ''
  }

  get contact_detail() {
    return this._contact_detail || ''
  }

  get minutes_spent() {
    return this._minutes_spent || 0
  }

  get notes() {
    return this._notes || ''
  }

  get navigator() {
    return this._navigator
  }

  get owned_by_consumer() {
    return this._owned_by_consumer
  }

  get source() {
    return this._source
  }

  // Calculable
  get getSourceType() {
    return pathOr('Unknown', ['source', '__typename'], this)
  }

  get isClaim() {
    return this.getSourceType === CLAIM
  }

  get isAppointment() {
    return this.getSourceType === APPOINTMENT
  }
}

export default Interaction
